module.exports = __webpack_public_path__ + "img/6.8.721f5c2c.jpg";